const TYPING_SPEED = {
  XSLOW: 50,
  SLOW: 10,
  FAST: 1
};

export { TYPING_SPEED };
